import { render, staticRenderFns } from "./NewWaybillEntry.vue?vue&type=template&id=351ff269&scoped=true&"
import script from "./NewWaybillEntry.vue?vue&type=script&lang=js&"
export * from "./NewWaybillEntry.vue?vue&type=script&lang=js&"
import style0 from "./NewWaybillEntry.vue?vue&type=style&index=0&id=351ff269&prod&scoped=true&lang=css&"
import style1 from "./NewWaybillEntry.vue?vue&type=style&index=1&id=351ff269&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351ff269",
  null
  
)

export default component.exports